export default __webpack_public_path__ + "static/media/kamila-camillo.9bc084dd.jpg";